'use strict';

var style = require('./style');

module.exports = style({
  prop: 'boxShadow',
  key: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/box-shadow.js
// module id = 4481
// module chunks = 168707334958949